
import require from '@/utils/request'
import { BasePage, Edit, TableRowInfoList, LinkSave } from '@/types/tenant/dataPage'
export const indexPageList = (params: BasePage) => require({
  url: '/blackcat/economic/indicator/page',
  method: 'get',
  params
})
export const indexPageUpdate = (data: TableRowInfoList) => require({
  url: '/blackcat/economic/indicator/update',
  method: 'post',
  data
})
export const dataPageList = (params: BasePage) => require({
  url: '/blackcat/linkinfo/page',
  method: 'get',
  params
})
export const dataPageSave = (data: LinkSave) => require({
  url: '/blackcat/linkinfo/save',
  method: 'post',
  data
})
export const selectTree = () => require({
  url: '/blackcat/economic/indicator/tree',
  method: 'get'
})
export const dataPageDetail = (params: Edit) => require({
  url: '/blackcat/linkinfo/detail',
  method: 'get',
  params
})
